import { render } from "./ButtonPagination.vue?vue&type=template&id=5145c86e&scoped=true"
import script from "./ButtonPagination.vue?vue&type=script&lang=js"
export * from "./ButtonPagination.vue?vue&type=script&lang=js"

import "./ButtonPagination.vue?vue&type=style&index=0&id=5145c86e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5145c86e"]])

export default __exports__